/**
 *
 * @param {object} field - object, field name, value, a validator function and a isValid boolean
 * @returns
 */

export default function (field) {
    if (!field.validator) {
        return (field.isValid = true)
    }

    if (
        field.dependentField &&
        field.dependentFieldValidator(field.dependentFieldValue)
    ) {
        return (field.isValid = true)
    } else if (field.dependentField && field.dependentFieldValue) {
        return (field.isValid = field.validator(field.value))
    }

    return (field.isValid = field.validator(field.value))
}
